export default __webpack_public_path__ + "static/media/test1.02d85f60.png";